module.exports = __webpack_public_path__ + "img/indus-pic-4.2b4a9a5d.png";